import cn from 'classnames'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import lang from 'lang'
import { changeModal } from 'services/actions'

@connect(null, (dispatch) => ({
  changeModal: (params) => dispatch(changeModal(params)),
}))
export default class AssignNudgeModal extends React.Component {
  static propTypes = {
    changeModal: PropTypes.func,
    onClickHandler: PropTypes.func,
    bodyText: PropTypes.string.isRequired,
    confirmText: PropTypes.string.isRequired,
    cancelText: PropTypes.string.isRequired,
    alert: PropTypes.bool,
  }

  closeModal() {
    this.props.changeModal({ isOpen: false })
  }

  render() {
    return (
      <div className="modal-wrapper">
        <div className="modal-header">
          <h2>{lang.dashboard.nudges.confirmAssignmentHeader}</h2>
          <p className="lead">{this.props.bodyText}</p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className={cn('button hollow', { alert: this.props.alert })}
            onClick={() => this.props.onClickHandler()}>
            {this.props.confirmText}
          </button>
          <button type="button" className="button clear cancel" onClick={() => this.closeModal()}>
            {this.props.cancelText}
          </button>
        </div>
      </div>
    )
  }
}
